__turbopack_context__.v({
  "coinBody": "Coin-module-scss-module__0cjpFW__coinBody",
  "coinContent": "Coin-module-scss-module__0cjpFW__coinContent",
  "coinDeco": "Coin-module-scss-module__0cjpFW__coinDeco",
  "coinDeco1": "Coin-module-scss-module__0cjpFW__coinDeco1",
  "coinDeco10": "Coin-module-scss-module__0cjpFW__coinDeco10",
  "coinDeco11": "Coin-module-scss-module__0cjpFW__coinDeco11",
  "coinDeco12": "Coin-module-scss-module__0cjpFW__coinDeco12",
  "coinDeco2": "Coin-module-scss-module__0cjpFW__coinDeco2",
  "coinDeco3": "Coin-module-scss-module__0cjpFW__coinDeco3",
  "coinDeco4": "Coin-module-scss-module__0cjpFW__coinDeco4",
  "coinDeco5": "Coin-module-scss-module__0cjpFW__coinDeco5",
  "coinDeco6": "Coin-module-scss-module__0cjpFW__coinDeco6",
  "coinDeco7": "Coin-module-scss-module__0cjpFW__coinDeco7",
  "coinDeco8": "Coin-module-scss-module__0cjpFW__coinDeco8",
  "coinDeco9": "Coin-module-scss-module__0cjpFW__coinDeco9",
});
